import { styled } from "styled-components";

import { useTranslate } from "@similarweb/i18n-provider";
import { SWReactIcons } from "@similarweb/icons";

import { StateContainer } from "./StateContainer";

const StyledSWReactIcons = styled(SWReactIcons)`
    width: 200px;
`;

export const EmptyState = () => {
    const { translate } = useTranslate();

    return (
        <StateContainer
            title={translate("platform.alerts.noDataToFetch.title")}
            subtitle={translate("platform.alerts.noDataToFetch.subtitle")}
        >
            <StyledSWReactIcons iconName="no-data-lab" />
        </StateContainer>
    );
};
